import type { Layout } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/components/RibbonControlGroupMLR';
import {
    sections,
    singleRow,
} from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon/components/RibbonControlGroupMLR/layoutTypings';
import { computedFn } from 'mobx-utils/lib/computedFn';
import { getComposeRibbonId } from 'owa-editor/lib/utils/getComposeRibbonId';
import type { ComposeViewState } from 'owa-mail-compose-store';
import { getMainWindowComposeViewState } from 'owa-mail-compose-actions/lib/selectors/getMainWindowComposeViewState';
import type { RibbonGroupId } from 'owa-ribbon-ids';
import { FormatControlId, MailRibbonGroupId } from 'owa-ribbon-ids';

export const getMLRTableFormatTabGroupLayouts = computedFn(
    (
        group: RibbonGroupId,
        popoutComposeViewState: ComposeViewState | undefined
    ): Layout[] | undefined => {
        const viewState: ComposeViewState | undefined =
            popoutComposeViewState ?? getMainWindowComposeViewState();
        switch (group) {
            case MailRibbonGroupId.Group_Table_Structure:
                return [
                    sections(
                        singleRow(
                            getComposeRibbonId(
                                FormatControlId.DeleteTableMenu,
                                viewState
                            ).toString()
                        )
                    ),
                ];

            case MailRibbonGroupId.Group_Table_Merge_Split:
                return [
                    sections(
                        singleRow(
                            getComposeRibbonId(
                                FormatControlId.TableMergeCellsMenu,
                                viewState
                            ).toString(),
                            getComposeRibbonId(
                                FormatControlId.TableSplitCellsMenu,
                                viewState
                            ).toString()
                        )
                    ),
                ];

            case MailRibbonGroupId.Group_Table_Insert:
                return [
                    sections(
                        singleRow(
                            getComposeRibbonId(
                                FormatControlId.InsertRowAbove,
                                viewState
                            ).toString(),
                            getComposeRibbonId(
                                FormatControlId.InsertRowBelow,
                                viewState
                            ).toString(),
                            getComposeRibbonId(
                                FormatControlId.InsertColumnLeft,
                                viewState
                            ).toString(),
                            getComposeRibbonId(
                                FormatControlId.InsertColumnRight,
                                viewState
                            ).toString()
                        )
                    ),
                ];

            case MailRibbonGroupId.Group_Table_Align:
                return [
                    sections(
                        singleRow(
                            getComposeRibbonId(
                                FormatControlId.TableAlignCellHorizontallyMenu,
                                viewState
                            ).toString(),
                            getComposeRibbonId(
                                FormatControlId.TableAlignCellVerticallyMenu,
                                viewState
                            ).toString()
                        )
                    ),
                ];
            default:
                return undefined;
        }
    }
);
